import "../styles/home.css";
import { useState, useEffect } from "react";
import { Carousel } from "primereact/carousel";
import { PrimeIcons } from "primereact/api";
import OffPlusController from "../services/offplus-controller";

export default function Home(props) {
	const offPlusController = new OffPlusController();
	const [banners, setBanners] = useState([]);

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			//> Get banners
			const bannersResult = await offPlusController.getBanners();
			if (bannersResult.isSuccess === false) throw bannersResult.message;
			setBanners(bannersResult.value);
			//>
		} catch (error) {
			alert(error.toString());
		}
	};

	const bannerTemplate = (banner) => {
		return (
			<div className="banner">
				<img src={banner.imageUrl} alt={banner.name} />
			</div>
		);
	};

	return (
		<>
			<Carousel
				value={banners}
				numVisible={1}
				numScroll={1}
				itemTemplate={bannerTemplate}
				autoplayInterval={3000}
				circular
			/>

			<div className="quick-access">
				<h2>دسترسی سریع</h2>

				<ul>
					<li>
						<a href="/#/login">
							<i className="pi pi-sign-in"></i>
							<span>عضویت</span>
							<p>ورود به پرتال</p>
						</a>
					</li>
					<li>
						<a href="/#/membership">
							<i className="pi pi-percentage"></i>
							<span>پرداخت حق عضویت</span>
							<p>با استفاده از امکانات امتیاز بگیرید</p>
						</a>
					</li>
					<li>
						<a href="/#/register">
							<i className="pi pi-user-edit"></i>
							<span>تکمیل پروفایل</span>
							<p>برای استفاده از  همه امکانات پروفایل را تکمیل کنید</p>
						</a>
					</li>
					<li>
						<a href="/#/booking-home">
							<i className={PrimeIcons.TICKET}></i>
							<span>رزرو اماکن اقامتی</span>
							<p>برای رزرو اماکن اقامتی وارد شوید</p>
						</a>
					</li>
				</ul>
			</div>

			<ul className="member-types">
				<li>
					<a href="/#/level-bronze">
						<img src="/images/bronze.jpg" alt="" />
						<h2>عضویت برنزی</h2>
						<p>عموم مردم</p>
					</a>
				</li>
				<li>
					<a href="/#/level-silver">
						<img src="/images/silver.jpg" alt="" />
						<h2>عضویت نقره ای</h2>
						<p>دهک 8 تا 10</p>
					</a>
				</li>
				<li>
					<a href="/#/level-gold">
						<img src="/images/gold.jpg" alt="" />
						<h2>عضویت طلایی</h2>
						<p>دهک 4 تا 7</p>
					</a>
				</li>
				<li>
					<a href="/#/level-platinum">
						<img src="/images/platinum.jpg" alt="" />
						<h2>عضویت پلاتینیوم</h2>
						<p>دهک 1 تا 3</p>
					</a>
				</li>
			</ul>

			<ul className="sections">
				<li>
					<a href="/#/booking-home">
						<img src="/images/section-locations.jpg" alt="" />
						<span>اماکن اقامتی</span>
					</a>
				</li>
				<li>
					<a href="/#/ticket-home">
						<img src="/images/section-sports.jpg" alt="" />
						<span>مراکز ورزشی</span>
					</a>
				</li>
				<li>
					<a href="/#/remote-store-types">
						<img src="/images/section-others.jpg" alt="" />
						<span>سایر مراکز و فروشگاه ها</span>
					</a>
				</li>
			</ul>
		</>
	);
}
